/*
 * Redux Middleware for handling API calls
 * On successful api response, the response and responseObj are attached to the action and passed to next middleware
 * On Error and error object is attached to the action and API_ERROR action is dispatched
 * Injection of config into the middleware to use it for authentication
 * config can be passed as a parameter to the middleware in applyMiddleware method when creating the store
 *
 */

import _ from 'lodash';
import { openDB, deleteDB, wrap, unwrap } from 'idb';
import MainWorker from '../webworkers/main.worker.js';
import env from '../util/env';

const unBookmark = (config) => (store) => (next) => (action) => {
	if (action.type != 'UNBOOKMARK_TASK') {
		return next(action);
	}

	const ONLINE_DB = 'ONLINE_DB',
		OFFLINE_DB = 'OFFLINE_DB';

	const dbPromise = openDB('canvas-idb', 1, {
		upgrade(db) {
			db.createObjectStore(ONLINE_DB);
			db.createObjectStore(OFFLINE_DB);
		}
	});

	const idbKeyval = {
		async get(key) {
			return (await dbPromise).get(ONLINE_DB, key);
		},
		async set(key, val) {
			return (await dbPromise).put(ONLINE_DB, val, key);
		},
		async setOffline(key, val) {
			return (await dbPromise).put(OFFLINE_DB, val, key);
		},
		async delete(key) {
			return (await dbPromise).delete(ONLINE_DB, key);
		},
		async clear() {
			return (await dbPromise).clear(ONLINE_DB);
		},
		async keys() {
			return (await dbPromise).getAllKeys(ONLINE_DB);
		}
	};

	if (!config) {
		const configMsg = `
		Config unavailable.
		The AD package requires config to get the authorization token for the api call.`;
		console.log(configMsg);
	}

	let tasklistUrl = action.url + 'tasks/?categoryId=2&subCategoryId=1';
	idbKeyval.get(tasklistUrl).then((tasklist) => {
		if (tasklist && tasklist.taskGroups[0].tasks) {
			tasklist.taskGroups[0].tasks = tasklist.taskGroups[0].tasks.filter(
				function (item) {
					return !action.taskIds.includes(item.id);
				}
			);
			idbKeyval.set(tasklistUrl, tasklist);
			if (tasklist.taskGroups[0].tasks.length == 0) {
				// all tasks are un bookmarked then remove the engagement from communicationchannel
				let cc = document.getElementById('communicationchannel');
				let clientDetails;
				if (_.isArray(store.getState().engagementMetaData)) {
					clientDetails = store.getState().engagementMetaData.find((item) => {
						return item.engagementid == store.getState().engagement.engagementId
					});
				}
				let cc_data = Object.assign({}, store.getState().engagement, {
					incountryuri: env.getURL('eng_web'),
					remove: true,
					clientid: clientDetails ? clientDetails.clientid : 0,
					clientname: clientDetails ? clientDetails.clientname : 'Invalid',
					herculesurl: env.getURL('hercules_web')
				});
				cc.contentWindow.postMessage(cc_data, env.getURL('Zeus_web'));
			}
		}
	});
	return next(action);
};

export default unBookmark;
